import { getStandardControlSemanticColorsWithTheme } from '@ms/app-commanding-ui';
import { isThemingEnabled } from '@ms/acui-theme/lib/ThemingExperiment';
var readOnlyColors = {
    background: '#f3f2f1',
    inputFocusBorder: '#c8c6c4',
    inputBorder: '#c8c6c4',
    disabledText: '#a19f9d',
    selectionBackground: '#797775',
    selectionTextColor: '#ffffff',
    inputBorderHovered: '#b3b0ad',
};
var getReadOnlyColorsWithTheme = function (theme) {
    if (!isThemingEnabled()) {
        return readOnlyColors;
    }
    var semanticColors = getStandardControlSemanticColorsWithTheme(theme);
    return {
        background: theme.palette.neutralLighterAlt,
        inputFocusBorder: semanticColors.borderColor,
        inputBorder: semanticColors.borderColor,
        disabledText: semanticColors.textDisabledColor,
        selectionBackground: theme.palette.neutralSecondary,
        selectionTextColor: semanticColors.inputSelectionTextColor,
        inputBorderHovered: theme.palette.neutralTertiary,
    };
};
export var getDocumentTitleInputReadOnlyStyles = function (props) {
    var focused = props.focused, theme = props.theme;
    var titleColors = getReadOnlyColorsWithTheme(theme);
    return {
        field: {
            borderColor: titleColors.inputBorder,
            backgroundColor: titleColors.background,
            color: titleColors.disabledText,
            selectors: {
                '::selection': {
                    backgroundColor: titleColors.selectionBackground,
                    color: titleColors.selectionTextColor,
                },
            },
        },
        fieldGroup: [
            {
                borderColor: focused ? titleColors.inputFocusBorder : titleColors.inputBorder,
            },
            !focused && {
                selectors: {
                    ':hover': {
                        borderColor: titleColors.inputBorderHovered,
                    },
                },
            },
        ],
        suffix: {
            backgroundColor: titleColors.background,
            color: titleColors.disabledText,
        },
    };
};
export var getDocumentTitleInputStyles = function () {
    return {
        suffix: {
            backgroundColor: 'transparent',
        },
        subComponentStyles: {
            label: {
                root: {
                    paddingTop: '0px',
                },
            },
        },
    };
};
//# sourceMappingURL=DocumentTitleCalloutInput.styles.js.map